import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { DYNAMICS_VARIABLE_REGEXP } from "@devowl-wp/headless-content-unblocker";
import { useFormService } from "../../../../../contexts/formService.js";
import { useI18n } from "../../../../../contexts/i18n.js";
import { Notices } from "../../../../common/notices.js";
const DYNAMICS_SEARCH_IN = [
    "codeOptIn",
    "codeOptOut",
    "codeOnPageLoad"
];
const FormServiceFieldHandlingDynamicField = ()=>{
    const { __ } = useI18n();
    const { template } = useFormService();
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>DYNAMICS_SEARCH_IN.map((k)=>prevValues[k] !== nextValues[k]).filter(Boolean).length > 0,
        children: ({ getFieldValue })=>{
            const searchInResolved = DYNAMICS_SEARCH_IN.map((k)=>getFieldValue(k)).join("");
            const matches = Array.from(searchInResolved.matchAll(DYNAMICS_VARIABLE_REGEXP)).map(([, m])=>m);
            const added = [];
            return matches ? matches.map((name)=>{
                const formName = [
                    "codeDynamics",
                    name
                ];
                const { label, invalidMessage = __("Please fill in a value!"), example, expression, hint } = template?.dynamicFields?.find((dynamicField)=>dynamicField.name === name) || {};
                if (added.indexOf(name) > -1) {
                    return null;
                }
                added.push(name);
                return /*#__PURE__*/ _jsxs(Form.Item, {
                    label: label || /*#__PURE__*/ _jsx("code", {
                        children: name
                    }),
                    required: true,
                    children: [
                        /*#__PURE__*/ _jsx(Form.Item, {
                            noStyle: true,
                            name: formName,
                            rules: [
                                {
                                    required: true,
                                    pattern: expression ? new RegExp(expression) : undefined,
                                    message: invalidMessage
                                }
                            ],
                            normalize: (value)=>value.trim(),
                            children: /*#__PURE__*/ _jsx(Input, {
                                placeholder: example
                            })
                        }),
                        /*#__PURE__*/ _jsx(Notices, {
                            notices: [
                                {
                                    message: hint,
                                    severity: "info"
                                }
                            ]
                        })
                    ]
                }, name);
            }) : null;
        }
    });
};
export { FormServiceFieldHandlingDynamicField };
